import RestApiModel from "@/api/Model/RestApiModel";
import api from '@/api';

class CoverholderPolicyPending extends RestApiModel {
  static getResourceEndpoint() {
    return '/CoverholderPolicyPending';
  }

  static coverholderFirmOrderAction(policyPk, language) {
    return api.get('/CoverholderFirmOrderAction', {
      params: { Policy_PK : policyPk, language }
    });
  }
}

export default CoverholderPolicyPending;
